import Masonry from 'masonry-layout';

const masonries = document.querySelectorAll('.masonry');

masonries.forEach((masonry) => {
  new Masonry(masonry);
});
